import firebase from "firebase";
const config = {
    apiKey: "AIzaSyBvx2YF1GEKN1kkzlJQXwaoWLvu5WMYrIQ",
    authDomain: "test-e-san.firebaseapp.com",
    projectId: "test-e-san",
    storageBucket: "test-e-san.appspot.com",
    messagingSenderId: "742894772995",
};
firebase.initializeApp(config);
export default firebase;